import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip'
import { cn } from '@/lib/cn'
import type { Priority } from '../../types'

const COLOR: Record<Priority, string> = {
  critical: 'bg-priority-critical',
  high: 'bg-priority-high',
  medium: 'bg-priority-medium',
  low: 'bg-priority-low',
}

const LABEL: Record<Priority, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
}

/**
 * A tiny coloured dot — the most space-efficient priority indicator.
 * Tooltip carries the human-readable label.
 */
export function PriorityDot({ priority }: { priority: Priority }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          aria-label={`Priority: ${LABEL[priority]}`}
          className={cn(
            'inline-block h-2 w-2 rounded-full',
            COLOR[priority],
            priority === 'critical' && 'ring-2 ring-priority-critical/30',
          )}
        />
      </TooltipTrigger>
      <TooltipContent>{LABEL[priority]}</TooltipContent>
    </Tooltip>
  )
}
